if (document.getElementById('page-user')) {
  page()
}

function page() {
  /*
      ###    ##       ##                ######  ##     ## ########  ######  ##    ##
    ##   ##  ##       ##               ##       ##     ## ##       ##       ##  ##
   ##     ## ##       ##       ####### ##       ######### ######   ##       #####
   ######### ##       ##               ##       ##     ## ##       ##       ##  ##
   ##     ## ######## ########          ######  ##     ## ########  ######  ##    ##

  同一グループすべてを切り替えるチェック

  <input type="checkbox" name="all" class="js-allCheck" data-all-check="hoge">
  <input type="checkbox" name="" class="js-allCheck--hoge js-allCheck-child " data-all-check="hoge">
  <input type="checkbox" name="" class="js-allCheck--hoge js-allCheck-child " data-all-check="hoge">
  */
  if (document.getElementsByClassName('js-allCheck')[0]) {
    allCheck()
  }
  function allCheck() {
    window.addEventListener('change', function (e) {
      if (e.target.classList.contains('js-allCheck')) {
        // 親の切り替えを子に反映する
        childUpdate(e)
        parentUpdate(e) // 親が複数あることを想定して親も更新する
      } else if (e.target.classList.contains('js-allCheck-child')) {
        // 子の状態を親に反映する
        parentUpdate(e)
      }
      return
    })
    function childUpdate(e) {
      const checked = e.target.checked // 親のチェック状態取得
      const group = e.target.dataset.allCheck // グループ取得
      const checkList = document.getElementsByClassName('js-allCheck--' + group) // 子チェックボックス
      // 親のチェック状態を子に伝播させる
      for (let index = 0; index < checkList.length; index++) {
        checkList[index].checked = checked
      }
    }
    function parentUpdate(e) {
      const group = e.target.dataset.allCheck // グループ取得
      const checkList = document.getElementsByClassName('js-allCheck--' + group) // 子チェックボックス
      const checkListChecked = document.querySelectorAll('.js-allCheck--' + group + ':checked') // チェック済みの子
      const checkCurrentList = document.querySelectorAll('.js-allCheck[data-all-check="' + group + '"]') // 親チェック

      // 子チェック数とチェックされている子チェックの数の比較結果が解になる
      const result = checkList.length === checkListChecked.length

      // すべての親チェックに結果を反映する
      for (const checkCurrent of checkCurrentList) {
        checkCurrent.checked = result
      }
    }
  }

  //   ####            ######  #####      ###     ####  #####
  //  ##                 ##    ##  ##    ## ##   ##     ##
  //  ##     ########    ##    #####    ##   ##  ##     #####
  //  ##                 ##    ##  ##   #######  ##     ##
  //   ####              ##    ##   ##  ##   ##   ####  #####
  /*
チェック内容を文字列やinputにトレース
js-allCheckと連携可能
<input type="checkbox" name="area[]" value="00000" class="js-checkTrace" data-trace-group="fuga" data-trace-name="テキストテキスト">
<input type="checkbox" name="area[]" value="11111" class="js-checkTrace"  data-trace-group="fuga" data-trace-name="テキストテキスト">
  */
  if (document.getElementsByClassName('js-checkTrace')[0]) {
    window.addEventListener('change', function (e) {
      if (!e.target.classList.contains('js-checkTrace')) {
        return
      }
      const group = e.target.dataset.traceGroup // グループ取得
      checkTrace(group)
    })
  }
  function checkTrace(group) {
    // チェック内容を各所に反映する
    let nameData = ''
    let valData = ''

    const checkListChecked = document.querySelectorAll('.js-checkTrace[data-trace-group="' + group + '"]:checked')

    let skipTarget = ''
    for (let index = 0; index < checkListChecked.length; index++) {
      const element = checkListChecked[index]

      if (element.classList.contains('js-allCheck')) {
        skipTarget = element.dataset.allCheck // 全体チェックは以降スキップする
      }
      if (element.classList.contains('js-allCheck--' + skipTarget)) {
        continue
      }

      if (nameData !== '') {
        nameData += ','
      }
      nameData += element.dataset.traceName
      if (valData !== '') {
        valData += ','
      }
      valData += element.value
    }

    let toggle = true
    if (nameData === '') {
      toggle = false
    }

    const textTarget = document.getElementsByClassName('js-checkTrace-text--' + group)
    for (let index = 0; index < textTarget.length; index++) {
      textTarget[index].innerHTML = nameData
    }
    const hideTarget = document.getElementsByClassName('js-checkTrace-toggle--' + group)
    if (toggle) {
      for (let index = 0; index < hideTarget.length; index++) {
        hideTarget[index].classList.add('active')
      }
    } else {
      for (let index = 0; index < hideTarget.length; index++) {
        hideTarget[index].classList.remove('active')
      }
    }
    const valueTarget = document.getElementsByClassName('js-checkTrace-input--' + group)
    for (let index = 0; index < valueTarget.length; index++) {
      valueTarget[index].value = valData
    }
    preSearch() // 検索件数取得
  }

  //  ##      ##   #####   #####    ####
  //  ##      ##  ##   ##  ##  ##   ##  ##
  //  ##  ##  ##  ##   ##  #####    ##  ##
  //  ##  ##  ##  ##   ##  ##  ##   ##  ##
  //   ###  ###    #####   ##   ##  ####

  // フリーワード処理
  if (document.getElementsByClassName('js-word-add')[0]) {
    window.addEventListener('click', function (e) {
      if (!e.target.classList.contains('js-word-add')) {
        return
      }
      const type = e.target.dataset.word
      freeWordAdd(type)
    })
  }
  window.addEventListener('keypress', function (e) {
    textWait(e)
  })
  window.addEventListener('input', function (e) {
    textWait(e)
  })
  function textWait(e) {
    const item = e.target.closest('.js-word')
    if (!item) {
      return
    }
    if (e.code && e.code === 'Enter') {
      e.preventDefault() // デフォルトのイベントを除去

      const type = e.target.dataset.word
      freeWordAdd(type)
      return false
    }
  }
  // 追加ボタン
  function freeWordAdd(type) {
    const inputList = document.getElementsByClassName('js-word--' + type)
    for (let index = 0; index < inputList.length; index++) {
      const input = inputList[index]

      let value = input.value
      if (value === '') {
        continue
      }

      // スペースを区切りにする
      // value = value.replace(' ', ',')
      // value = value.replace('　', ',')

      // 表示を反映
      const viewList = document.getElementsByClassName('js-word-view--' + type)
      for (let index = 0; index < viewList.length; index++) {
        const view = viewList[index]
        if (view.innerText !== '') {
          view.innerText += ','
        }
        view.innerText += value
      }

      // inputフィールドを反映
      let allValue = ''
      const hiddenList = document.getElementsByClassName('js-word-input--' + type)
      for (let index = 0; index < hiddenList.length; index++) {
        const hidden = hiddenList[index]
        if (hidden.value !== '') {
          hidden.value += ','
        }
        hidden.value += value
        allValue = hidden.value
      }

      // 入力に反応する要素を反映
      const toggle = document.getElementsByClassName('js-word-toggle--' + type)
      for (let index = 0; index < toggle.length; index++) {
        toggle[index].classList.add('active')
      }

      input.value = ''
    }
    preSearch() // 検索件数取得
  }

  //   ####  ##      #####    ###    #####
  //  ##     ##      ##      ## ##   ##  ##
  //  ##     ##      #####  ##   ##  #####
  //  ##     ##      ##     #######  ##  ##
  //   ####  ######  #####  ##   ##  ##   ##

  // クリア処理
  if (document.getElementsByClassName('js-clear')[0]) {
    window.addEventListener('click', function (e) {
      if (!e.target.classList.contains('js-clear')) {
        return
      }

      e.preventDefault() // デフォルトのイベントを除去
      const text = e.target.dataset.clear
      const group = e.target.dataset.group

      window.dialogOpen(text + 'の入力内容をクリアします', 'クリアする', 'キャンセル', 'js-clearAgree', group)
    })
  }
  window.addEventListener('click', function (e) {
    // 指定のIDを持つ
    if (e.target.id === 'js-clearAgree') {
      clear(e.target.dataset.dialog)
    }
  })

  function clear(group) {
    // 各条件をクリアしていく
    let target = '--' + group
    if (group === 'all') {
      // allグループは識別子を無視してすべて消す
      target = ''
    }

    // 入力系リセット
    const inputList = document.getElementsByClassName('js-clear-input' + target)
    for (let index = 0; index < inputList.length; index++) {
      if (inputList[index].tagName === 'SELECT') {
        inputList[index].selectedIndex = 0
      } else {
        inputList[index].value = ''
      }
    }

    // チェックボックスリセット
    const checkList = document.getElementsByClassName('js-clear-check' + target)
    for (let index = 0; index < checkList.length; index++) {
      checkList[index].checked = false
    }

    // テキストリセット
    const textList = document.getElementsByClassName('js-clear-text' + target)
    for (let index = 0; index < textList.length; index++) {
      let resetText = ''
      // if (textList[index].classList.contains('js-word-view')) {
      //   resetText = '' // フリーワードは空欄にする
      // }
      textList[index].innerText = resetText
    }

    // 特定要素を隠蔽
    const hideList = document.getElementsByClassName('js-clear-hide' + target)
    for (let index = 0; index < hideList.length; index++) {
      hideList[index].classList.remove('active')
    }
    preSearch() // 検索件数取得
  }

  //  #####   #####    #####
  //  ##  ##  ##  ##   ##
  //  #####   #####    #####
  //  ##      ##  ##   ##
  //  ##      ##   ##  #####

  window.addEventListener('input', function (e) {
    const item = e.target.closest('#jobSearch')
    if (!item) {
      return
    }
    preSearch()
  })

  let ajax = false // Ajaxリクエスト
  let ajaxResponse = '' // 最後のレスポンスを格納する
  let lastUrl = '' // 最後に送ったURL
  preSearch()
  function preSearch() {
    /* global hUrl */

    let url = hUrl + 'job/?count=1'

    const inputList = document
      .getElementById('jobSearch')
      .querySelectorAll('[type="hidden"],select,[type="checkbox"]:checked,[type="radio"]:checked')

    for (const input of inputList) {
      if (input.name === '') {
        continue
      }
      url += '&' + input.name + '=' + input.value
    }
    applyAjax(url, 'get')

    function applyAjax(url, method = 'get') {
      if (url === lastUrl) {
        // 前と同じURLなら中止
        return
      }
      if (ajax) {
        // 既に通信中なら切断
        ajax.abort()
      }
      // カウント取得中の表示に切り替える
      const targetList = document.getElementsByClassName('js-preCount')
      for (const iterator of targetList) {
        iterator.innerText = '...'
      }

      lastUrl = url

      ajax = new XMLHttpRequest() // Ajaxリクエスト

      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理

      ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー

      ajax.responseType = 'text' // 取得タイプ document text json
      ajax.timeout = 10000 // タイムアウト判定時間

      ajax.send() // GETリクエスト実行

      ajax.onload = function () {
        // アクセス成功
        if (ajax.status < 200 || ajax.status >= 400) {
          console.log('Error: Code ' + ajax.status) // エラー
          return
        }

        ajaxResponse = ajax.response // 取得結果を更新
        // console.log(ajaxResponse)

        // カウントを反映する
        const count = parseInt(ajaxResponse, 10)
        for (const iterator of targetList) {
          iterator.innerText = count
        }
      }
      ajax.ontimeout = function (e) {
        // タイムアウト
      }
      ajax.onerror = function () {
        // Ajax処理失敗
      }
      ajax.onloadend = function () {
        // 受信成否に関わらず実行
        // intObsAjax()
        ajax = false
      }
    }
  }
}
